import Swiper from 'swiper';
import HtmlElement from './HtmlElement';

/**
 * Swiper Slider
 *
 * @return SwiperSlider
 */
const SwiperSlider = (() => {
  /**
   * Selector
   *
   * @var { Object }
   */
  const Selector = {
    CONTAINER: '.swiper-container',
    WRAPPER: '.swiper-wrapper',
    SLIDE: '.swiper-slide',
    PAGINATION: '.swiper-pagination'
  };

  /**
   * Class Name
   *
   * @var { Object }
   */
  const ClassName = {
    INITIALIZED: 'swiper-initialized'
  };

  /**
   * Swiper Slider
   *
   * @class
   * @augments HtmlElement
   */
  class SwiperSlider extends HtmlElement {

    /**
     * @constructor
     */
    constructor($element) {
      super($element);

      this._length = 0;
      this._defaults = {
        on: {
          init: () => {
            this.$element.addClass(ClassName.INITIALIZED);
          }
        }
      };
    }

    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._length = this.$element.find(Selector.SLIDE).length;
      this.setOptions();
    }

    /**
     * Sets the options for the slider
     *
     * @param { Object } options
     * @return void
     */
    setOptions(options = {}) {
      this._options = {
        ...this._defaults,
        ...options
      };
    }

    // Private

    /**
     * Initializes the slider
     *
     * @return void
     */
    _initialize() {
      new Swiper(this.$element, this._options);
    }

    // Getters

    /**
     * Returns the Selector constant
     *
     * @return { Object } Selector
     */
    static get Selector() {
      return Selector;
    }

    /**
     * Returns the ClassName constant
     *
     * @return { Object } ClassName
     */
    static get ClassName() {
      return ClassName;
    }
  }

  return SwiperSlider;
})();

export default SwiperSlider;
